// extracted by mini-css-extract-plugin
export default {"content":"styles_content__OM8iC","time":"styles_time__a7gec"};